import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CGU_TEXT } from "@/content/cgu";

function parse(text) {
  const blocks = [];
  const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
  lines.forEach((l, i) => {
    const prevList = i > 0 && lines[i - 1].endsWith(";");
    if (/^Article \d+/.test(l)) blocks.push({ t: "h2", v: l });
    else if (/^\d+\.\d+ –/.test(l)) blocks.push({ t: "h3", v: l });
    else if (l.endsWith(";") || prevList) {
      const last = blocks[blocks.length - 1];
      if (last?.t === "ul") last.v.push(l);
      else blocks.push({ t: "ul", v: [l] });
    } else blocks.push({ t: "p", v: l });
  });
  return blocks;
}

const BLOCKS = parse(CGU_TEXT);

const Block = ({ b }) => {
  if (b.t === "h2") return <h2 className="mt-10 font-serif text-xl text-[#065F46]">{b.v}</h2>;
  if (b.t === "h3") return <h3 className="mt-5 text-sm font-bold uppercase tracking-wide text-[#B08D57]">{b.v}</h3>;
  if (b.t === "ul") return <ul className="my-3 list-disc space-y-1 pl-6">{b.v.map((x) => <li key={x}>{x}</li>)}</ul>;
  return <p className="my-2">{b.v}</p>;
};

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] px-5 py-10 sm:px-10" data-testid="mentions-legales-page">
      <div className="mx-auto max-w-3xl">
        <Link to="/" data-testid="mentions-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-500 transition-colors hover:text-[#065F46]">
          <ArrowLeft className="h-4 w-4" /> Retour
        </Link>
        <p className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-[#B08D57]">Mentions légales</p>
        <h1 className="mt-2 font-serif text-3xl text-gray-900 sm:text-4xl">Conditions générales d'utilisation (CGU)</h1>
        <p className="mt-3 text-sm text-gray-500" data-testid="cgu-version">Éditeur : Fabien Deris EI · Version du 4 novembre 2026</p>
        <article className="mt-6 text-sm leading-relaxed text-gray-700 sm:text-base" data-testid="cgu-content">
          {BLOCKS.map((b, i) => <Block key={i} b={b} />)}
        </article>
        <footer className="mt-12 border-t border-gray-200 pt-6 text-xs text-gray-500">
          <p>© 2026 Fabien Deris EI – Tous droits réservés sur les éléments protégés appartenant à l'Éditeur.</p>
          <p className="mt-1">Toute reproduction ou exploitation non autorisée des éléments protégés est interdite, sous réserve des exceptions légales et des licences applicables.</p>
        </footer>
      </div>
    </div>
  );
}
